import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Spinner from '@components/common/Spinner/Spinner';
import Text from '@components/common/Text/Text';
import { personRoles } from '@models/PotModel/personRoles';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './BannerMessage.module.scss';

type BannerMessageProps = {
    onOpenMessageForm: () => void;
    isActivated: boolean;
    hasMessage: boolean;
    isLoading: boolean;
    messagesCount: number;
    potRef: string;
    onDeleteMessage: () => void;
    personRole: string;
};

const BannerMessage = ({
    onOpenMessageForm,
    isActivated,
    hasMessage,
    isLoading,
    messagesCount,
    onDeleteMessage,
    personRole,
    potRef,
}: BannerMessageProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <>
            {isActivated ? (
                <>
                    {!hasMessage ? (
                        <div className={css.container}>
                            {isLoading ? (
                                <Spinner />
                            ) : (
                                <>
                                    {personRole === personRoles.BENEFICIARY ? (
                                        <>
                                            <div className={css.container__first_message}>
                                                <h5>
                                                    {t('greeting-card.you-have-messages')}
                                                    <img
                                                        className={css.container__first_message__img}
                                                        src="/front-static/icons/display/handwriting.svg"
                                                        alt="writting"
                                                    />
                                                </h5>
                                            </div>
                                            <Link
                                                href={getRoute(ROUTE.LPC.POT.POT, potRef, ROUTE.LPC.POT.GREETING_CARD)}
                                            >
                                                <Button
                                                    variant={'white'}
                                                    customClass={css.greeting__header__right__preview}
                                                >
                                                    {t('greeting-card.preview')}
                                                </Button>
                                            </Link>
                                        </>
                                    ) : (
                                        <>
                                            <div className={css.container__first_message}>
                                                <h5>
                                                    {messagesCount > 0
                                                        ? t('greeting-card.add-message-title')
                                                        : t('greeting-card.first-message-title')}
                                                    <img
                                                        className={css.container__first_message__img}
                                                        src="/front-static/icons/display/handwriting.svg"
                                                        alt="writting"
                                                    />
                                                </h5>
                                            </div>
                                            <Button
                                                onClick={() => onOpenMessageForm()}
                                                customClass={css.cta}
                                                variant={'white'}
                                            >
                                                {t('greeting-card.first-message-desc')}
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    ) : (
                        <div className={`${css.container} ${css.container__solid}`}>
                            {isLoading ? (
                                <Spinner />
                            ) : (
                                <>
                                    <div className={css.container__checkmark}>
                                        <h5>{t('greeting-card.success-message-title')}</h5>
                                        <img src={'/front-static/icons/display/checkmark.svg'} />
                                    </div>
                                    <div className={css.container__row}>
                                        <Button
                                            onClick={() => onOpenMessageForm()}
                                            customClass={css.cta}
                                            variant={'white'}
                                        >
                                            {t('greeting-card.success-message-desc')}
                                        </Button>
                                        <Button
                                            onClick={() => onDeleteMessage()}
                                            customClass={css.cta}
                                            variant={'error'}
                                        >
                                            {t('greeting-card.delete-message')}
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </>
            ) : (
                <div className={`${css.container} ${css.container__deactivated}`}>
                    {isLoading ? (
                        <Spinner />
                    ) : (
                        <>
                            <img src="/front-static/icons/display/lock.svg" alt="deactivate" />
                            <h5>{t('greeting-card.deactivate-message-title')}</h5>
                            <Text variant={'caption_02'} color={'txt-secondary'}>
                                {t('greeting-card.deactivate-message-desc')}
                            </Text>
                        </>
                    )}
                </div>
            )}
        </>
    );
};
export default BannerMessage;
